import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title=" You are our strong pillars" />
      {/*<h1 className="headtext__cormorant">GroNelk's Goals</h1>*/}

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">With our infectious love of literature and fine arts, we are poised to </p>
        </div>
        <p className="p__opensans"> engage the non-dogmatic and sharp minds on thinking of 
        implementable strategies to tackle real problems that face us today.
         We also give parties interested in lifelong learning, opportunities to express their
        thoughts through written works of research and essays- with visionary force and poetic import."</p>
      </div>

      <div className="app__chef-sign">
        <p>Grold Otieno</p>
        <p className="p__opensans">Founder</p> 
        <img src={images.sign} alt="sign_image" />
      </div>
    </div>
  </div>
);

export default Chef;